import { useRecords } from './useRecords'

export const useRecordsInfinite = useRecords

export default useRecordsInfinite
